/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetReprocessOverridesQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetReprocessOverrides";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetReprocessOverrides } from "../../clients/document-use-casesService/documentUseCasesControllerGetReprocessOverrides";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetReprocessOverridesQueryKey = () => [{
  url: '/api/v1/documents/processings/reprocess-overrides'
}] as const;
export type DocumentUseCasesControllerGetReprocessOverridesQueryKey = ReturnType<typeof documentUseCasesControllerGetReprocessOverridesQueryKey>;
export function documentUseCasesControllerGetReprocessOverridesQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetReprocessOverridesQueryKey();
  return queryOptions<DocumentUseCasesControllerGetReprocessOverridesQueryResponse, ResponseErrorConfig<Error>, DocumentUseCasesControllerGetReprocessOverridesQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetReprocessOverrides(config);
    }
  });
}

/**
 * @description Returns each overridable setting with its current deployed default and accepted bounds, keyed to the step it applies to. Read this rather than hardcoding defaults — they change with config.
 * @summary Get the per-run overrides the reprocess API accepts
 * {@link /api/v1/documents/processings/reprocess-overrides}
 */
export function useDocumentUseCasesControllerGetReprocessOverrides<TData = DocumentUseCasesControllerGetReprocessOverridesQueryResponse, TQueryData = DocumentUseCasesControllerGetReprocessOverridesQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetReprocessOverridesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetReprocessOverridesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetReprocessOverridesQueryKey();
  const query = useQuery({
    ...documentUseCasesControllerGetReprocessOverridesQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}